/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Palette_Go_ToInputs */

const en_palette_go_to = /** @type {(inputs: Palette_Go_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to`)
};

/**
* | output |
* | --- |
* | "Go to" |
*
* @param {Palette_Go_ToInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const palette_go_to = /** @type {((inputs?: Palette_Go_ToInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Palette_Go_ToInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_palette_go_to(inputs)
});